import { Companies } from "modules/deliveryCompanies";

const CompaniesPage = () => {
  return <Companies />;
};

export default CompaniesPage;
